@if (plotlyData().length > 0) {
  <div class="flex flex-col h-full">
    <div id="legend-instructions" class="sr-only">
      {{ 'graphs.legend.instructions' | transloco }}
    </div>
    <div aria-live="polite" aria-atomic="false" class="sr-only">{{ dragFeedback() }}</div>
    @if (disabled()) {
      <div
        id="legend-refresh-hint"
        role="note"
        class="flex items-center gap-(--space-2) mb-(--space-3) text-sm text-(color:--text-secondary)">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <span>{{ 'graphs.legend.refreshHint' | transloco }}</span>
      </div>
    }
    <div cdkDropList class="space-y-(--space-2) overflow-y-auto min-h-0" (cdkDropListDropped)="drop.emit($event)">
      @for (trace of plotlyData(); track getTraceKey(trace, $index)) {
        <div
          cdkDrag
          [cdkDragDisabled]="disabled()"
          [attr.tabindex]="disabled() ? -1 : 0"
          role="button"
          [attr.aria-disabled]="disabled() ? 'true' : null"
          [attr.aria-label]="trace.name + (isTraceHidden(trace) ? ' ' + getHiddenLabel() : '')"
          [attr.aria-describedby]="disabled() ? 'legend-instructions legend-refresh-hint' : 'legend-instructions'"
          (click)="toggleVisibility.emit($index)"
          (keydown)="keyDown.emit({ event: $event, index: $index })"
          [class.opacity-50]="isTraceHidden(trace)"
          [class.pointer-events-none]="disabled()"
          class="flex items-center gap-(--space-2) px-(--space-2) py-(--space-2) transition-colors duration-200 hover:bg-white hover:bg-opacity-60 rounded-[var(--radius-sm)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--p-primary-ui)] focus-visible:ring-offset-2 select-none cursor-pointer">
          <div
            *cdkDragPreview
            class="flex items-center gap-(--space-2) px-(--space-2) py-(--space-2) bg-white rounded-[var(--radius-sm)] border border-[var(--p-primary-ui)] border-opacity-20">
            <app-legend-line [line]="trace.line" [marker]="trace.marker" />
            <span class="text-sm font-medium">{{ trace.name }}</span>
          </div>

          <div
            class="flex items-center gap-(--space-2) flex-1 min-w-0"
            [class.opacity-60]="disabled()"
            [cesEllipsisTooltip]="trace.name"
            ellipsisTarget=".truncate"
            tooltipPosition="top"
            [appendTo]="tooltipAnchor">
            <app-legend-line [line]="trace.line" [marker]="trace.marker" />
            <span class="text-sm font-medium truncate">{{ trace.name }}</span>
          </div>

          <button
            type="button"
            [disabled]="disabled()"
            (click)="configure.emit($index); $event.stopPropagation()"
            [class]="
              'group flex items-center justify-center ' +
              actionButtonSize +
              ' rounded hover:bg-[var(--surface-hover)] transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--p-primary-ui)] focus:ring-offset-2 cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-transparent'
            "
            [attr.aria-label]="getConfigureLabel(trace.name)">
            <ces-icon size="xl" customClass="transition-colors group-hover:text-[var(--p-primary-ui)]"> instant_mix </ces-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
